import styled from 'styled-components';

const BoldFont = 'Rubik-Medium';
const RegularFont = 'Rubik-Regular';

const ChampionTab = styled.div`
  height: auto;
  @media (max-width: 500px) {
    padding: 20px 10px;
  }
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  float: left;
  font-size: 12px;
  text-transform: uppercase;
  text-align: left;
  position: relative;
  h3 {
    font-family: ${RegularFont};
    font-size: 20px;
    color: #000;
    padding-left: 5px;
    text-transform: capitalize;
  }
`;

const ChampionsCard = styled.div`
  display: inline-block;
  width: calc(100%/4);
  position: relative;
  float: left;
  @media (max-width: 1200px) {
    width: calc(100%/3);
  }
  @media(max-width: 760px) {
    width: calc(100%/2);
    float: left;
  } 
  @media(max-width: 500px) {
    width: 100%;
  }
  > div {
    height: 100%;
    padding: 10px 12px;
    padding: ${({margin }) => margin ? margin : '0px 0px 15px 0'};
  }
`;
const WellnessChampionsHeader = styled.div`
  font-family: ${BoldFont};
  float: left;
  font-size: 14px;
  color: #FFFFFF;
  text-transform: uppercase;
  width: 100%;
  padding: 13px 0 13px 13px;
  background-color: #1C4667;
  border-radius: 6px 6px 6px 6px
  
  @media (max-width: 760px) {
    text-align: left;
  }
`;

const UserCard = styled.div`
width:288px;
display:flex;
background: #FEFEFE99;
border-radius:6px;
padding: 16px 8px;
flex-wrap:wrap;
.image{
  display:flex;
  width:100%;
  justify-content:center;
  >img{
    width:80px;
    height:80px;
    margin:auto;
    border-radius: 50%;
  }
}
.name{
  font-family: Lato;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #184A61;
  display:flex;
  width:100%; 
  margin: 16px 0 8px 0;
  justify-content:center;
  align-items:center;
  text-transform: capitalize;
}
.department{
  font-family: Lato;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #184A61;
  display:flex;
  width:100%; 
  justify-content:center;
  align-items:center;
  text-transform: capitalize;
}
.location{
  font-family: Lato;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #184A61;
  margin: 8px 0 8px 0;
  display:flex;
  width:100%; 
  justify-content:center;
  align-items:center;
  text-transform: capitalize;
}

.wellnes-wrap{
  display:flex;
  width:100%; 
  justify-content:center;
  align-items:center;
  gap:20px;
  margin: 8px 0;
  >img{
    width:24px;
    height:24px;
    filter: invert(55%) sepia(25%) saturate(600%) hue-rotate(170deg) brightness(90%) contrast(90%);
  }
}
.points{
  width:100%;
  background: #EFEFEF;
  justify-content:center;
  align-items:center;
  font-family: Lato;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: center;
  color: #184A61;
  border-radius:6px;
  margin-top:16px;
  padding:12px;
  text-transform: capitalize;
}
`;

export { ChampionTab, CardContainer , ChampionsCard, WellnessChampionsHeader, UserCard}